import React, { ReactElement } from "react";
import i18n from "@i18n";
import { NavButtonConfig } from "./QuestionDefinition";
import { Text } from "../core/Text";
import Button, { Props } from "src/design-system/components/Button/Button";
import { StickyBar, StickyModes } from "../core/StickyBar";
import { Interpolation, Theme } from "@emotion/react";
import { isRedesignEnabled } from "src/utils/userSegment/features";

export interface ControlsProperties {
  next?: NavButtonConfig;

  isLoading?: boolean;
  canProceed?: boolean;

  /** Callback handler executed when the user clicks the next button. */
  onClickNext?: () => void;
  children?: ReactElement;

  hideControls?: boolean;
  useStickyControls?: boolean;
  useStickyControlsAllViewports?: boolean;
  hideGradientForStickyControls?: boolean;
  "data-cy"?: string;
  width?: string;
  buttonDesignStyle?: Props["designStyle"];
  buttonCss?: Interpolation<Theme>;
  stickyBarCss?: Interpolation<Theme>;
}

export default function Controls({
  next = { text: i18n.t("survey-controls-2:next") },
  isLoading,
  canProceed,
  onClickNext,
  children,
  hideControls = false,
  useStickyControls = false,
  useStickyControlsAllViewports = false,
  hideGradientForStickyControls = false,
  "data-cy": dataCy = "survey-next",
  width,
  buttonDesignStyle = isRedesignEnabled() ? "redesignTertiary" : "primaryCta",
  buttonCss,
  stickyBarCss,
}: ControlsProperties) {
  if (hideControls || (next && next.disabled)) {
    return null;
  }

  let sticky: StickyModes = "none";
  if (canProceed) {
    if (useStickyControls) {
      sticky = "mobile";
    } else if (useStickyControlsAllViewports) {
      sticky = "all";
    }
  }

  return (
    <StickyBar
      height="60px"
      sticky={sticky}
      hideGradient={hideGradientForStickyControls}
      width={width}
      css={stickyBarCss}
    >
      {children}
      <Button
        designStyle={buttonDesignStyle}
        type={onClickNext ? "button" : "submit"}
        onClick={onClickNext && (() => onClickNext())}
        disabled={!canProceed || isLoading}
        data-cy={dataCy}
        css={buttonCss}
      >
        <Text i18nKeyOrText={next.text} />
      </Button>
    </StickyBar>
  );
}
